'use strict';

require('./curry.js');
require('./chunk-ba04ad2f.js');
var empty = require('./empty.js');
var head = require('./head.js');
var tail = require('./tail.js');
var last = require('./last.js');
require('./_dropWhile.js');
require('./_takeWhile.js');
require('./_span.js');
var span = require('./span.js');
var _prepend = require('./_prepend.js');

function chunkBy(c, as) {
  var b = head(as);
  var bs = span(function (a) {
    return c(a, b);
  }, tail(as));
  return empty(as) ? [] : _prepend(_prepend(b, head(bs)), chunkBy(c, last(bs)));
}

module.exports = chunkBy;
